<template>
  <CDialog v-bind="{ show }" no-header body-class="!max-w-[421px]">
    <div class="p-5">
      <CRoundedIcon
        class="!text-4.5xl"
        :color="
          botStatusType ? '!text-green bg-green-100' : '!text-red bg-red-100'
        "
        :icon="
          botStatusType ? 'icon-filled-tick-circle' : 'icon-filled-warning'
        "
      />
      <p
        class="text-center mt-5 text-xl leading-130 font-semibold text-dark-100"
      >
        {{
          botStatusType
            ? $t("bot_status.activate_title")
            : $t("bot_status.deactivate_title")
        }}
      </p>
      <p
        class="text-base leading-130 font-normal text-gray-700 text-center mt-2 mx-auto"
      >
        {{
          botStatusType
            ? $t("bot_status.activate_desc")
            : $t("bot_status.deactivate_desc")
        }}
      </p>
      <div class="mt-7 flex-y-center gap-4">
        <CButton
          variant="info"
          class="w-full"
          @click="onClose"
          :text="$t('cancel')"
        />
        <CButton
          :variant="botStatusType ? 'success_info' : 'error'"
          class="w-full"
          :text="
            botStatusType
              ? $t('bot_status.activate')
              : $t('bot_status.deactivate')
          "
          @click="handleBotStartOrStop"
          :loading="botStore.statusLoading"
        />
      </div>
    </div>
  </CDialog>
</template>

<script setup lang="ts">
import CDialog from "@/components/Common/Dialog/CDialog.vue";
import CRoundedIcon from "@/components/Common/CRoundedIcon.vue";
import CButton from "@/components/Common/CButton.vue";
import ApiService from "@/services/ApiService";
import { useBotStore } from "@/modules/Bots/stores";
import { computed } from "vue";

interface Props {
  loading?: boolean;
}
defineProps<Props>();
const emit = defineEmits<{
  (e: "fetchData"): void;
}>();

const botStore = useBotStore();

const botStatusType = computed(() => botStore.bot.status);
const show = computed(() => botStore.statusModal);

function onClose() {
  botStore.statusModal = false;
}
function handleBotStartOrStop() {
  botStore.statusLoading = true;
  ApiService.post(
    `/bot/${botStatusType.value ? "start" : "stop"}/${botStore.bot.id}/`,
  )
    .then(async () => {
      emit("fetchData");
      botStore.statusModal = false;
    })
    .catch((err) => {
      console.log(err, "err");
    })
    .finally(() => {
      botStore.statusLoading = false;
    });
}
</script>
